import {PageHeader, TabsComponent} from '@/components/molecules'
import {FONT_SIZE} from '@/utils/constants/globalStyle'
import {OverviewTab, TierTab} from '@/containers/ClubPlus/Tabs'
import {useIntl} from 'react-intl'
import {useActiveTiers} from '@/containers/ClubPlus/hooks/useActiveTiers'

export const ClubPlusHome = () => {
  const {formatMessage} = useIntl()
  const {tiers} = useActiveTiers()

  const overviewTab = [
    {
      id: 'overview',
      tabLabel: formatMessage({id: 'CLUB_PLUS.TIER_OVERVIEW_TAB_LABEL'}),
      title: formatMessage({id: 'CLUB_PLUS.TIER_OVERVIEW_TAB_LABEL'}),
      tabComponent: <OverviewTab />,
    },
  ]

  const tierTabs = tiers
    ? tiers.map(tier => ({
        id: tier.name.toLowerCase(),
        tabLabel: tier.name,
        title: tier.name,
        tabComponent: <TierTab tierID={tier.tierID} />,
      }))
    : []

  const tabList = [...overviewTab, ...tierTabs]

  return (
    <section>
      <PageHeader title={formatMessage({id: 'CLUB_PLUS.TITLE'})} fontSize={FONT_SIZE.XXXL} />
      <TabsComponent tabList={tabList} />
    </section>
  )
}
